import PropTypes from 'prop-types';
import React from 'react';

class MobileHome extends React.Component {

  render() {
    return (
      <div className="container">
        <div className="panel">
          <h1>Welcome to Catch!</h1>
          <div>Ready to start your Group Travel? Download our app!</div>
          <div>
            <a href="https://itunes.apple.com/us/app/catch-mobile/id1221985667?ls=1&mt=8">iTunes</a>
            or <a href="https://play.google.com/store/apps/details?id=com.usecatch">Google Play</a></div>
        </div>
      </div>
    );
  }
}

export default MobileHome;



// WEBPACK FOOTER //
// src/routes/home/components/MobileHome.js